/* eslint-disable max-len */
type Props = {
  text: string;
};

const TimelineArrow = ({ text }: Props) => {
  return (
    <div className="tw-pb-3">
      <svg width="100" height="28.73" viewBox="0 0 100 28.73" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.29781 1.09238C9.58146 0.719154 10.0233 0.5 10.4921 0.5H85C85.8284 0.5 86.5 1.17157 86.5 2V23C86.5 23.8284 85.8284 24.5 85 24.5H10.492C10.0233 24.5 9.58146 24.2808 9.29781 23.9076L1.31781 13.4076C0.910132 12.8712 0.910132 12.1288 1.31781 11.5924L9.29781 1.09238Z"
          fill="#E6F5FC"
          stroke="#B0CCD8"
        />
        <text
          x="45%"
          y="50%"
          dominant-baseline="middle"
          text-anchor="middle"
          fill="#2C5466"
          fontWeight="500"
          fontSize="10px"
          fontFamily="inter"
        >
          {text}
        </text>
      </svg>
    </div>
  );
};

export default TimelineArrow;
